// returns indexes
export default function keys() {
  var length = this.length;
  var result = new Array(length);
  for (var i = 0; i < length; i++) {
    result[i] = i;
  }
  return result;
}